class CartRecommendations extends HTMLElement {
  constructor() {
    super();
    this.initialized = false;
  }

  connectedCallback() {
    // Use IntersectionObserver to lazy-load when drawer opens
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !this.initialized) {
          this.loadRecommendations();
          observer.unobserve(this);
        }
      });
    });
    observer.observe(this);
  }

  async loadRecommendations() {
    this.initialized = true;
    const url = this.dataset.url;
    if (!url) return;

    try {
      const response = await fetch(url);
      const text = await response.text();
      const html = new DOMParser().parseFromString(text, 'text/html');
      const recommendations = html.querySelector('cart-recommendations');

      if (recommendations && recommendations.innerHTML.trim().length) {
        this.innerHTML = recommendations.innerHTML;
        this.initSwiper();
      }
    } catch (e) {
      console.error('Cart recommendations error:', e);
    }
  }

  initSwiper() {
    const swiperEl = this.querySelector('.cart-recommendations__swiper .swiper');
    if (!swiperEl || typeof Swiper === 'undefined') return;

    const swiper = new Swiper(swiperEl, {
      slidesPerView: 1,
      spaceBetween: 12,
      navigation: {
        prevEl: this.querySelector('.cart-recommendations__prev'),
        nextEl: this.querySelector('.cart-recommendations__next'),
      },
    });
  }
}

customElements.define('cart-recommendations', CartRecommendations);

// Refresh recommendations when cart updates
document.addEventListener('cart:updated', () => {
  document.querySelectorAll('cart-recommendations').forEach((el) => {
    el.initialized = false;
    el.loadRecommendations();
  });
});